document.addEventListener('DOMContentLoaded', function () {
  if (window.__rovInit) return;
  window.__rovInit = true;


  // ---- CART BADGE ----
  var lnavBadge = document.querySelector('.lnav-cart__badge.js-cart-count');
  if (lnavBadge) {
    function syncLnavBadge() {
      var count = parseInt(lnavBadge.textContent, 10);
      lnavBadge.style.display = count > 0 ? '' : 'none';
    }
    syncLnavBadge();
    new MutationObserver(syncLnavBadge).observe(lnavBadge, { childList: true, characterData: true, subtree: true });
  }

  // ---- GALLERY SLIDER ----
  document.querySelectorAll('[data-slider]').forEach(function (slider) {
    var sectionId = slider.getAttribute('data-slider');
    var thumbs = slider.querySelectorAll('.rov-thumb');
    var slides = slider.querySelectorAll('.rov-slide');
    var thumbsContainer = slider.querySelector('[data-thumbnails="' + sectionId + '"]');
    var navUp = slider.querySelector('.rov-thumb-nav--up');
    var navDown = slider.querySelector('.rov-thumb-nav--down');

    function isMobile() {
      return window.innerWidth <= 768;
    }

    function setSlide(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;

      slides.forEach(function (slide) {
        var isActive = parseInt(slide.dataset.slide, 10) === index;
        slide.classList.toggle('rov-slide--active', isActive);

        var video = slide.querySelector('.rov-slide__video');
        if (video) {
          if (isActive) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        }
      });
      thumbs.forEach(function (thumb) {
        thumb.classList.toggle('rov-thumb--active', parseInt(thumb.dataset.slide, 10) === index);
      });

      scrollToActive();
    }

    function checkArrows() {
      if (!thumbsContainer || isMobile()) {
        if (navUp) navUp.classList.remove('rov-thumb-nav--visible');
        if (navDown) navDown.classList.remove('rov-thumb-nav--visible');
        return;
      }
      var scrollTop = thumbsContainer.scrollTop;
      var scrollMax = thumbsContainer.scrollHeight - thumbsContainer.clientHeight;
      var tol = 4;
      if (navUp) navUp.classList.toggle('rov-thumb-nav--visible', scrollTop > tol);
      if (navDown) navDown.classList.toggle('rov-thumb-nav--visible', scrollTop < scrollMax - tol);
    }

    function scrollToActive() {
      if (!thumbsContainer) return;
      var activeThumb = thumbsContainer.querySelector('.rov-thumb--active');
      if (!activeThumb) return;

      if (isMobile()) {
        var left = activeThumb.offsetLeft;
        var w = activeThumb.offsetWidth;
        var cLeft = thumbsContainer.scrollLeft;
        var cW = thumbsContainer.clientWidth;
        if (left < cLeft) thumbsContainer.scrollLeft = left - 8;
        else if (left + w > cLeft + cW) thumbsContainer.scrollLeft = left + w - cW + 8;
      } else {
        var top = activeThumb.offsetTop;
        var h = activeThumb.offsetHeight;
        var cTop = thumbsContainer.scrollTop;
        var cH = thumbsContainer.clientHeight;
        if (top < cTop) thumbsContainer.scrollTop = top - 8;
        else if (top + h > cTop + cH) thumbsContainer.scrollTop = top + h - cH + 8;
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setSlide(parseInt(this.dataset.slide, 10));
      });
    });

    if (navUp) navUp.addEventListener('click', function () {
      if (thumbsContainer) thumbsContainer.scrollBy({ top: -140, behavior: 'smooth' });
      setTimeout(checkArrows, 300);
    });
    if (navDown) navDown.addEventListener('click', function () {
      if (thumbsContainer) thumbsContainer.scrollBy({ top: 140, behavior: 'smooth' });
      setTimeout(checkArrows, 300);
    });
    window.addEventListener('resize', checkArrows);

    // Expose for engraving preview
    slider._setSlide = setSlide;
    slider._getActiveIndex = function () {
      var active = slider.querySelector('.rov-slide--active');
      return active ? parseInt(active.dataset.slide, 10) : 0;
    };

    setSlide(0);
  });

  // ---- ADDON CHECKBOXES: REVEAL DETAILS ON CHECK ----
  document.querySelectorAll('.rov-addon__checkbox').forEach(function (checkbox) {
    var addon   = checkbox.closest('.rov-addon');
    var details = addon && addon.querySelector('.rov-addon__details');
    if (!details) return;

    var isEngravingToggle = checkbox.hasAttribute('data-engraving-toggle');

    // Engraving preview references (only for the engraving checkbox)
    var engSlider       = isEngravingToggle ? document.querySelector('[data-slider]') : null;
    var engPreviewSlide = engSlider && engSlider.querySelector('.rov-slide--engrave-preview');
    var engPreviewThumb = engSlider && engSlider.querySelector('.rov-thumb--engrave');
    var engCanvas       = engPreviewSlide && engPreviewSlide.querySelector('.rov-engraving-canvas');
    var engInput        = isEngravingToggle ? details.querySelector('input[name="properties[Engraving]"]') : null;
    var engFontInput    = isEngravingToggle ? details.querySelector('input[name="properties[Engraving Font]"]') : null;
    var engFontSelector = isEngravingToggle ? details.querySelector('[data-font-selector]') : null;
    var engPrevIndex    = 0;
    var engActiveFont   = 'EngravingMTCorsiva';
    var engCanvasMobile = isEngravingToggle ? details.querySelector('.rov-engraving-canvas-mobile') : null;

    function drawOnCanvas(canvas, text) {
      if (!canvas) return;
      var wrap = canvas.parentElement;
      var w = Math.round(canvas.offsetWidth) || (wrap ? wrap.offsetWidth : 600) || 600;
      var h = Math.round(canvas.offsetHeight) || (wrap ? wrap.offsetHeight : 400) || 400;
      if (canvas.width !== w || canvas.height !== h) {
        canvas.width  = w;
        canvas.height = h;
      }
      var ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, w, h);
      if (!text) return;

      // Arc tuned to match the inner-band engraving position in the ring interior photo.
      // cx/cy is the projected ring-center; r is the inner-rim radius at that perspective.
      var cx = w * 0.50;   // ring center X — horizontally centered
      var cy = h * 0.99;   // ring center Y — 3% higher
      var r  = h * 0.72;   // inner rim radius

      var midAngle = -Math.PI / 2;
      var maxArc   = Math.PI * 0.60;

      var fontSize = Math.max(14, Math.round(h * 0.078));
      ctx.font         = fontSize + 'px ' + engActiveFont + ', serif';
      ctx.textAlign    = 'center';
      ctx.textBaseline = 'middle';

      // Measure each character so spacing is always proportional to actual width
      var charWidths = [];
      var textOnlyPx = 0;
      for (var i = 0; i < text.length; i++) {
        var cw = ctx.measureText(text[i]).width;
        charWidths.push(cw);
        textOnlyPx += cw;
      }

      // Start with a comfortable gap, then compress if total arc exceeds the ring band
      var gap      = 4;
      var totalPx  = textOnlyPx + gap * (text.length - 1);
      var totalArc = totalPx / r;
      if (totalArc > maxArc) {
        var available = maxArc * r - textOnlyPx;
        gap      = text.length > 1 ? Math.max(1, available / (text.length - 1)) : 0;
        totalPx  = textOnlyPx + gap * (text.length - 1);
        totalArc = totalPx / r;
      }

      // Clip to the visible inner ring band — characters outside are cut off cleanly
      ctx.save();
      ctx.beginPath();
      ctx.rect(w * 0.14, 0, w * 0.72, h * 0.60);
      ctx.clip();

      var cursor = midAngle - totalArc / 2;
      for (var i = 0; i < text.length; i++) {
        var charAngle = cursor + (charWidths[i] / 2) / r;
        var tx = cx + r * Math.cos(charAngle);
        var ty = cy + r * Math.sin(charAngle);

        // Pass 1 — dark offset stroke for engraved depth/shadow
        ctx.save();
        ctx.translate(tx, ty);
        ctx.lineWidth     = 0.5;
        ctx.strokeStyle   = 'rgba(0, 0, 0, 0.5)';
        ctx.shadowColor   = 'transparent';
        ctx.strokeText(text[i], 1.2, 1.2);
        ctx.restore();

        // Pass 2 — white skeleton stroke (engraved groove catching light)
        ctx.save();
        ctx.translate(tx, ty);
        ctx.lineWidth     = 0.5;
        ctx.strokeStyle   = 'rgba(255, 255, 255, 0.92)';
        ctx.shadowColor   = 'rgba(0, 0, 0, 0.4)';
        ctx.shadowBlur    = 1.5;
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 0;
        ctx.strokeText(text[i], 0, 0);
        ctx.restore();

        cursor += (charWidths[i] + gap) / r;
      }

      ctx.restore(); // release clip
    }

    function updateEngravingCanvas(text) {
      drawOnCanvas(engCanvas, text);
      drawOnCanvas(engCanvasMobile, text);
    }

    if (engInput) {
      var charCountEl = engInput.parentElement && engInput.parentElement.querySelector('.rov-char-count');
      var maxLen      = parseInt(engInput.getAttribute('maxlength'), 10) || 20;

      function updateCharCount() {
        if (!charCountEl) return;
        var used = engInput.value.length;
        var left = maxLen - used;
        charCountEl.textContent = used + ' / ' + maxLen;
        charCountEl.classList.toggle('rov-char-count--warn', left <= 5 && left > 0);
        charCountEl.classList.toggle('rov-char-count--full', left === 0);
      }

      engInput.addEventListener('input', function () {
        updateEngravingCanvas(engInput.value);
        updateCharCount();
      });
    }

    if (engFontSelector) {
      engFontSelector.querySelectorAll('.rov-font-option').forEach(function (btn) {
        btn.addEventListener('click', function () {
          engFontSelector.querySelectorAll('.rov-font-option').forEach(function (b) {
            b.classList.remove('rov-font-option--active');
          });
          btn.classList.add('rov-font-option--active');
          engActiveFont = btn.getAttribute('data-font-id') || engActiveFont;
          if (engFontInput) engFontInput.value = btn.getAttribute('data-font-name') || '';
          updateEngravingCanvas(engInput ? engInput.value : '');
        });
      });
    }

    checkbox.addEventListener('change', function () {
      details.hidden = !checkbox.checked;

      if (isEngravingToggle) {
        var zoomBtn = engSlider ? engSlider.querySelector('.rov-zoom-btn') : null;

        if (!checkbox.checked) {
          if (engInput) engInput.value = '';
          if (engPreviewThumb) engPreviewThumb.classList.remove('is-visible');
          if (engSlider && engSlider._setSlide) engSlider._setSlide(engPrevIndex);
          if (engCanvas) {
            var ctx = engCanvas.getContext('2d');
            if (ctx) ctx.clearRect(0, 0, engCanvas.width, engCanvas.height);
          }
          if (zoomBtn) zoomBtn.style.display = '';
        } else {
          if (engSlider && engSlider._getActiveIndex) engPrevIndex = engSlider._getActiveIndex();
          if (engInput) setTimeout(function () { engInput.focus(); }, 50);
          if (zoomBtn) zoomBtn.style.setProperty('display', 'none', 'important');
          requestAnimationFrame(function () {
            var isMob = window.innerWidth <= 768;
            if (!isMob) {
              if (engPreviewThumb) engPreviewThumb.classList.add('is-visible');
              if (engPreviewSlide && engSlider && engSlider._setSlide) {
                engSlider._setSlide(parseInt(engPreviewSlide.dataset.slide, 10));
              }
            }
            updateEngravingCanvas(engInput ? engInput.value : '');
          });
        }
      }
    });
  });

  // ---- SIZE EXPAND TOGGLE ----
  document.querySelectorAll('.rov-size-expand-btn').forEach(function (expandBtn) {
    var group = expandBtn.closest('.rov-size-btns');
    if (!group) return;

    var allSizeBtns = Array.from(group.querySelectorAll('.rov-size-btn'));
    if (!allSizeBtns.length) return;

    var overflowBtns = [];
    var textEl       = expandBtn.querySelector('.rov-size-expand-text');
    var svgEl        = expandBtn.querySelector('svg');
    var resizeTimer;

    function top(el) {
      return Math.round(el.offsetTop);
    }

    function collapse() {
      // Reset: show everything, clear list
      allSizeBtns.forEach(function (b) { b.style.display = ''; });
      expandBtn.style.display = '';
      overflowBtns = [];

      var firstTop = top(allSizeBtns[0]);

      // All fit on one row — no expand button needed
      if (top(expandBtn) === firstTop) {
        expandBtn.style.display = 'none';
        return;
      }

      // Hide size buttons from the end until expand button lands on the first row
      for (var i = allSizeBtns.length - 1; i >= 0; i--) {
        overflowBtns.unshift(allSizeBtns[i]);
        allSizeBtns[i].style.display = 'none';
        if (top(expandBtn) === firstTop) break;
      }

      expandBtn.setAttribute('aria-expanded', 'false');
      if (textEl) textEl.innerHTML = 'More<br>sizes';
      if (svgEl) svgEl.style.transform = '';
    }

    // Double rAF: first frame queues the paint, second fires after layout is stable
    requestAnimationFrame(function () {
      requestAnimationFrame(collapse);
    });

    expandBtn.addEventListener('click', function () {
      var expanded = expandBtn.getAttribute('aria-expanded') === 'true';
      expanded = !expanded;
      expandBtn.setAttribute('aria-expanded', String(expanded));
      overflowBtns.forEach(function (b) { b.style.display = expanded ? '' : 'none'; });
      if (textEl) textEl.innerHTML = expanded ? 'Less<br>sizes' : 'More<br>sizes';
      if (svgEl) svgEl.style.transform = expanded ? 'rotate(180deg)' : '';
    });

    // Re-collapse on resize only when not expanded
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (expandBtn.getAttribute('aria-expanded') !== 'true') collapse();
      }, 150);
    });
  });

  // ---- VARIANT OPTION BUTTONS ----
  (function () {
    var sectionGroups = {};
    document.querySelectorAll('[data-option-btns]').forEach(function (group) {
      var sid = group.getAttribute('data-option-btns');
      if (!sectionGroups[sid]) sectionGroups[sid] = [];
      sectionGroups[sid].push(group);
    });

    Object.keys(sectionGroups).forEach(function (sid) {
      var groups      = sectionGroups[sid];
      var hiddenInput = document.getElementById('rov-size-hidden-' + sid);
      var buyInput    = document.getElementById('rov-buy-id-' + sid);
      var variants    = window['rovVariants_' + sid] || [];
      var prices      = window['rovVariantPrices_' + sid] || {};
      var currency    = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';

      function getSelectedOptions() {
        return groups.map(function (g) {
          var active = g.querySelector('.rov-size-btn--active');
          return active ? active.getAttribute('data-option-value') : null;
        });
      }

      function resolveVariant(opts) {
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return opts[i] === o; });
        }) || null;
      }

      function updatePrice(variantId) {
        var cents = prices[variantId];
        if (cents === undefined) return;
        var formatted = (cents / 100).toLocaleString('en-US', { style: 'currency', currency: currency });
        ['rov-sticky-atc-price-' + sid, 'rov-mob-atc-price-' + sid].forEach(function (id) {
          var el = document.getElementById(id);
          if (el) el.textContent = formatted;
        });
      }

      function syncVariant() {
        var activeBtn = groups[0] ? groups[0].querySelector('.rov-size-btn--active') : null;
        var directId  = activeBtn ? activeBtn.getAttribute('data-variant-id') : null;
        var variantId;

        if (directId) {
          variantId = directId;
        } else {
          var v = resolveVariant(getSelectedOptions());
          variantId = v ? String(v.id) : null;
        }

        if (variantId) {
          if (hiddenInput) hiddenInput.value = variantId;
          if (buyInput)    buyInput.value    = variantId;
          updatePrice(parseInt(variantId, 10));
        }
      }

      groups.forEach(function (group) {
        group.querySelectorAll('.rov-size-btn').forEach(function (btn) {
          btn.addEventListener('click', function () {
            group.querySelectorAll('.rov-size-btn').forEach(function (b) {
              b.classList.remove('rov-size-btn--active');
            });
            this.classList.add('rov-size-btn--active');
            syncVariant();
          });
        });
      });
    });
  })();

  // ---- ADD TO CART → OPEN CART DRAWER ----
  var cartForm = document.querySelector('.rov-form');
  if (cartForm) {
    cartForm.addEventListener('submit', function (e) {
      e.preventDefault();

      var btn = cartForm.querySelector('[type="submit"]');
      var originalHTML = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }

      // Build items array
      var variantInput = cartForm.querySelector('[name="id"]');
      var variantId    = variantInput ? parseInt(variantInput.value) : null;
      var engravingInputId = cartForm.dataset.engravingInput;
      var engravingEl      = engravingInputId ? document.getElementById(engravingInputId) : null;
      var engravingText    = engravingEl ? engravingEl.value.trim() : '';
      var engravingFontId  = cartForm.dataset.engravingFont;
      var engravingFontEl  = engravingFontId ? document.getElementById(engravingFontId) : null;
      var engravingFont    = engravingFontEl ? engravingFontEl.value : '';
      var engravingVariantId = cartForm.dataset.engravingVariant
                               ? parseInt(cartForm.dataset.engravingVariant)
                               : null;
      var woodenBoxVariantId  = cartForm.dataset.woodenBoxVariant
                               ? parseInt(cartForm.dataset.woodenBoxVariant)
                               : null;
      var woodenBoxCheckboxId = cartForm.dataset.woodenBoxCheckbox;
      var woodenBoxChecked    = woodenBoxCheckboxId
                               ? !!(document.getElementById(woodenBoxCheckboxId) || {}).checked
                               : false;

      if (!variantId) return;

      // Validate: if engraving toggle is checked, text must not be empty
      var engravingToggle = document.querySelector('[data-engraving-toggle]');
      if (engravingToggle && engravingToggle.checked && !engravingText) {
        if (btn) { btn.disabled = false; btn.innerHTML = originalHTML; }
        if (engravingEl) {
          engravingEl.classList.add('rov-input--error');
          engravingEl.focus();
          engravingEl.addEventListener('input', function () {
            engravingEl.classList.remove('rov-input--error');
          }, { once: true });
        }
        return;
      }

      var engProps = {};
      if (engravingText) {
        engProps['Engraving'] = engravingText;
        if (engravingFont) engProps['Engraving Font'] = engravingFont;
      }
      var items = [{ id: variantId, quantity: 1, properties: engProps }];

      // Add engraving fee product when text is present and fee product is configured
      if (engravingText && engravingVariantId) {
        items.push({
          id: engravingVariantId,
          quantity: 1,
          properties: { 'Ring engraving': engravingText }
        });
      }

      // Add wooden box when checkbox is checked and product is configured
      if (woodenBoxChecked && woodenBoxVariantId) {
        items.push({ id: woodenBoxVariantId, quantity: 1 });
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          var configEl = document.getElementById('cart-config');
          var config = configEl ? JSON.parse(configEl.innerHTML || '{}') : {};
          if (typeof Shopify !== 'undefined' && Shopify.theme && Shopify.theme.ajaxCart) {
            Shopify.theme.cart.getCart().then(function (Cart) {
              Shopify.theme.ajaxCart.updateView(config, Cart);
              Shopify.theme.ajaxCart.showDrawer(config);
            });
          } else {
            WAU.Popover.show('slideout-ajax-cart');
          }
        })
        .catch(function () {
          window.location.href = '/cart';
        })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.innerHTML = originalHTML; }
        });
    });
  }

  // ---- BUY IT NOW → DIRECT CHECKOUT ----
  var buyForm = document.querySelector('.rov-buy-form');
  if (buyForm) {
    buyForm.addEventListener('submit', function (e) {
      e.preventDefault();

      var btn = buyForm.querySelector('[type="submit"]');
      var originalHTML = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Processing…'; }

      var variantId          = parseInt(buyForm.querySelector('[name="id"]').value, 10);
      var engravingInputId   = buyForm.dataset.engravingInput;
      var engravingEl        = engravingInputId ? document.getElementById(engravingInputId) : null;
      var engravingText      = engravingEl ? engravingEl.value.trim() : '';
      var engravingFontId    = buyForm.dataset.engravingFont;
      var engravingFontEl    = engravingFontId ? document.getElementById(engravingFontId) : null;
      var engravingFont      = engravingFontEl ? engravingFontEl.value : '';
      var engravingVariantId = buyForm.dataset.engravingVariant
                               ? parseInt(buyForm.dataset.engravingVariant, 10) : null;
      var woodenBoxVariantId  = buyForm.dataset.woodenBoxVariant
                               ? parseInt(buyForm.dataset.woodenBoxVariant, 10) : null;
      var woodenBoxCheckboxId = buyForm.dataset.woodenBoxCheckbox;
      var woodenBoxChecked    = woodenBoxCheckboxId
                               ? !!(document.getElementById(woodenBoxCheckboxId) || {}).checked
                               : false;

      // Validate: if engraving toggle is checked, text must not be empty
      var engravingToggleBuy = document.querySelector('[data-engraving-toggle]');
      if (engravingToggleBuy && engravingToggleBuy.checked && !engravingText) {
        if (btn) { btn.disabled = false; btn.innerHTML = originalHTML; }
        if (engravingEl) {
          engravingEl.classList.add('rov-input--error');
          engravingEl.focus();
          engravingEl.addEventListener('input', function () {
            engravingEl.classList.remove('rov-input--error');
          }, { once: true });
        }
        return;
      }

      var buyEngProps = {};
      if (engravingText) {
        buyEngProps['Engraving'] = engravingText;
        if (engravingFont) buyEngProps['Engraving Font'] = engravingFont;
      }
      var items = [{ id: variantId, quantity: 1, properties: buyEngProps }];

      if (engravingText && engravingVariantId) {
        items.push({
          id: engravingVariantId,
          quantity: 1,
          properties: { 'Ring engraving': engravingText }
        });
      }

      if (woodenBoxChecked && woodenBoxVariantId) {
        items.push({ id: woodenBoxVariantId, quantity: 1 });
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () { window.location.href = '/checkout'; })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.innerHTML = originalHTML; }
        });
    });
  }

  // ---- IMAGE LIGHTBOX (zoom button click + double-click) ----
  document.querySelectorAll('[data-lightbox-gallery]').forEach(function (gallery) {
    var sectionId = gallery.getAttribute('data-lightbox-gallery');
    var lightbox = document.getElementById('rov-lightbox-' + sectionId);
    if (!lightbox) return;

    // Teleport to <body> so it sits above all stacking contexts incl. sticky header
    document.body.appendChild(lightbox);

    var lbImg   = lightbox.querySelector('.rov-lightbox__img');
    var lbVideo = lightbox.querySelector('.rov-lightbox__video');
    var closeBtn = lightbox.querySelector('.rov-lightbox__close');
    var zoomBtn  = gallery.querySelector('.rov-zoom-btn');

    function getActiveSlide() {
      return gallery.querySelector('.rov-slide--active');
    }

    function openImageLightbox(src, alt) {
      lightbox.classList.remove('rov-lightbox--video');
      lbImg.src = '';
      lbImg.src = src;
      lbImg.alt = alt || '';
      if (lbVideo) { lbVideo.pause(); lbVideo.src = ''; }
      lightbox.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function openVideoLightbox(inlineVideo) {
      lightbox.classList.add('rov-lightbox--video');
      if (lbVideo) {
        lbVideo.src = '';
        var mp4 = inlineVideo.querySelector('source[type="video/mp4"]');
        if (mp4) lbVideo.src = mp4.src;
        lbVideo.currentTime = inlineVideo.currentTime || 0;
        inlineVideo.pause();
        lightbox.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        lbVideo.play().catch(function () {});
      }
    }

    function closeLightbox() {
      lightbox.classList.remove('is-open', 'rov-lightbox--video');
      document.body.style.overflow = '';
      lbImg.src = '';
      if (lbVideo) { lbVideo.pause(); lbVideo.src = ''; }
      // Resume inline video if video slide is still active
      var activeSlide = getActiveSlide();
      if (activeSlide && activeSlide.dataset.mediaType === 'video') {
        var inlineVid = activeSlide.querySelector('.rov-slide__video');
        if (inlineVid) inlineVid.play().catch(function () {});
      }
    }

    function handleOpen() {
      var slide = getActiveSlide();
      if (!slide) return;
      if (slide.dataset.mediaType === 'video') {
        var inlineVid = slide.querySelector('.rov-slide__video');
        if (inlineVid) openVideoLightbox(inlineVid);
      } else {
        var img = slide.querySelector('.rov-zoomable');
        if (img) openImageLightbox(img.getAttribute('data-full') || img.src, img.alt);
      }
    }

    if (zoomBtn) zoomBtn.addEventListener('click', handleOpen);

    // Click on expand button overlay (video slides)
    gallery.addEventListener('click', function (e) {
      if (e.target.closest('.rov-slide__video-expand')) handleOpen();
    });

    // Double-click image to zoom
    gallery.addEventListener('dblclick', function (e) {
      var img = e.target.closest('.rov-zoomable');
      if (!img) return;
      openImageLightbox(img.getAttribute('data-full') || img.src, img.alt);
    });

    closeBtn.addEventListener('click', closeLightbox);

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target === lightbox.querySelector('.rov-lightbox__img-wrap')) {
        closeLightbox();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightbox.classList.contains('is-open')) {
        closeLightbox();
      }
    });
  });

  // ---- SIZE GUIDE MODAL ----
  document.querySelectorAll('.rov-size-guide-trigger').forEach(function (trigger) {
    var guideId = trigger.getAttribute('data-guide');
    var overlay = document.getElementById('rov-size-guide-' + guideId);
    if (!overlay) return;

    // Teleport to <body> so it sits above all stacking contexts (incl. sticky header)
    document.body.appendChild(overlay);

    function openModal() {
      overlay.classList.add('rov-modal-overlay--open');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      overlay.classList.remove('rov-modal-overlay--open');
      document.body.style.overflow = '';
    }

    trigger.addEventListener('click', openModal);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });

    var closeBtn = overlay.querySelector('.rov-modal__close');
    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('rov-modal-overlay--open')) {
        closeModal();
      }
    });
  });

  // ---- WHAT'S INCLUDED POPOVER ----
  document.querySelectorAll('.rov-whats-included-wrap').forEach(function (wrap) {
    var btn = wrap.querySelector('.rov-whats-included-btn');
    var closeBtn = wrap.querySelector('.rov-wi-close');
    var popover = wrap.querySelector('.rov-whats-included-popover');
    if (!btn || !popover) return;

    function open() {
      popover.classList.add('is-open');
      wrap.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    }

    function close() {
      popover.classList.remove('is-open');
      wrap.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    }


    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      popover.classList.contains('is-open') ? close() : open();
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        close();
      });
    }

    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target) && !popover.contains(e.target)) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popover.classList.contains('is-open')) close();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) close();
      }, { threshold: 0 }).observe(wrap);
    }
  });

  // ---- CART DRAWER: LOADER + ENGRAVING SYNC ----
  var cartDrawer = document.getElementById('slideout-ajax-cart');
  if (cartDrawer) {
    var cartLoader   = cartDrawer.querySelector('.js-mini-cart-loader');
    var cartFormWrap = cartDrawer.querySelector('.ajax-cart__form-wrapper');

    function getEngravingVariantId() {
      var f = document.querySelector('.rov-form[data-engraving-variant]');
      if (f) return parseInt(f.dataset.engravingVariant) || null;
      var cfg = getCartConfig();
      return cfg.engraving_variant_id || null;
    }

    function getWoodenBoxVariantId() {
      var f = document.querySelector('.rov-form[data-wooden-box-variant]');
      if (f) return parseInt(f.dataset.woodenBoxVariant) || null;
      var cfg = getCartConfig();
      return cfg.wooden_box_variant_id || null;
    }

    function getCartConfig() {
      var el = document.getElementById('cart-config');
      return el ? JSON.parse(el.innerHTML || '{}') : {};
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    }

    function showCartLoader() {
      if (!cartLoader) return;
      cartLoader.style.display = 'flex';
      cartLoader.style.opacity = '1';
      cartLoader.classList.remove('animate-hide', 'fadeOut');
      cartLoader.classList.add('animate-show', 'fadeIn');
    }

    function hideCartLoader() {
      if (!cartLoader) return;
      cartLoader.style.opacity = '0';
      setTimeout(function () { cartLoader.style.display = 'none'; }, 300);
    }

    // Add wooden box to cart for a ring item
    function addWoodenBox(trigger) {
      var woodenBoxVariantId = getWoodenBoxVariantId();
      if (!woodenBoxVariantId) return;

      trigger.disabled = true;
      trigger.textContent = 'Adding…';

      showCartLoader();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: woodenBoxVariantId, quantity: 1 })
      })
        .then(function () { return applyCartUpdates({}); })
        .catch(function () { hideCartLoader(); trigger.disabled = false; trigger.textContent = '+ Add Wooden Box — $20'; });
    }

    // After every updateView rerender: show engraving text, hide fee rows, inject "Add Engraving" triggers
    function patchEngravingDisplay() {
      var engravingVariantId = getEngravingVariantId();
      var woodenBoxVariantId = getWoodenBoxVariantId();

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var feeByText = {};
          var engDomEls = [];

          // Collect paid engraving fee items (if engraving fee product is still configured)
          if (engravingVariantId) {
            cart.items.forEach(function (item, idx) {
              var domEl = cartDrawer.querySelector('.item_' + item.id + '-' + (idx + 1));
              if (item.variant_id === engravingVariantId) {
                var t = item.properties && item.properties['Ring engraving'];
                if (t) feeByText[t] = item.price;
                if (domEl) engDomEls.push(domEl);
              }
            });
            engDomEls.forEach(function (el) { el.style.display = 'none'; });
          }

          // Pre-compute wooden box quantity in cart for 1-to-1 hint logic
          var woodenBoxQtyInCart = 0;
          if (woodenBoxVariantId) {
            cart.items.forEach(function (i) {
              if (i.variant_id === woodenBoxVariantId) woodenBoxQtyInCart += i.quantity;
            });
          }
          var ringRunningQty = 0;

          cart.items.forEach(function (item, idx) {
            // Skip addon items — they are not rings and don't need hints
            if (item.variant_id === engravingVariantId) return;
            if (woodenBoxVariantId && item.variant_id === woodenBoxVariantId) return;

            var domEl = cartDrawer.querySelector('.item_' + item.id + '-' + (idx + 1));
            if (!domEl) return;

            var engText   = item.properties && item.properties['Engraving'];
            var detailsEl = domEl.querySelector('.ajax-cart__item-details');

            // Policy note
            domEl.querySelectorAll('.rov-engraving-policy').forEach(function (el) { el.remove(); });
            if (engText && detailsEl) {
              var policy = document.createElement('p');
              policy.className = 'rov-engraving-policy';
              policy.textContent = 'Engraved item: not eligible for size exchange, return, or refund.';
              detailsEl.appendChild(policy);
            }

            // Paid fee row (only when fee product is configured)
            domEl.querySelectorAll('.rov-engraving-fee-row').forEach(function (el) { el.remove(); });
            if (engravingVariantId && engText && (engText in feeByText)) {
              var priceCell = domEl.querySelector('.ajax-cart__item-price');
              if (priceCell) {
                var row = document.createElement('div');
                row.className = 'rov-engraving-fee-row';
                row.innerHTML =
                  '<span class="rov-engraving-fee-label">+ Engraving</span>' +
                  '<span class="rov-engraving-fee-price">+' + formatMoney(feeByText[engText]) + '</span>';
                priceCell.appendChild(row);
              }
            }

            if (!detailsEl) return;

            // "Add Engraving" trigger — 1-to-1: show for every ring item without engraving
            detailsEl.querySelectorAll('.rov-engrave-panel').forEach(function (el) { el.remove(); });
            if (!engText) {
              var panel = document.createElement('div');
              panel.className = 'rov-engrave-panel';
              panel.dataset.itemKey = item.key;
              panel.dataset.itemQty = item.quantity;
              var cartFonts = [
                { id: 'EngravingMTCorsiva',           name: 'Corsiva' },
                { id: 'EngravingTimesNewRoman',        name: 'Times' },
                { id: 'EngravingArial',                name: 'Arial' },
                { id: 'EngravingCINZEL',               name: 'Cinzel' },
                { id: 'EngravingCourgette',            name: 'Courgette' },
                { id: 'EngravingBrushScript',          name: 'Brush' },
                { id: 'EngravingShadowsIntoLightTwo',  name: 'Shadows' }
              ];
              var fontBtns = cartFonts.map(function (f, i) {
                return '<button type="button" class="rov-cart-font-opt' + (i === 0 ? ' rov-cart-font-opt--active' : '') + '"' +
                  ' data-font-id="' + f.id + '" data-font-name="' + f.name + '"' +
                  ' style="font-family:\'' + f.id + '\',serif">' + f.name + '</button>';
              }).join('');
              panel.innerHTML =
                '<button type="button" class="rov-engrave-trigger">+ Add Engraving <strong>— Free</strong></button>' +
                '<div class="rov-engrave-form">' +
                '<div class="rov-engrave-input-wrap">' +
                '<input type="text" class="rov-engrave-input" maxlength="20" placeholder="Your engraving text...">' +
                '<span class="rov-engrave-count">0 / 20</span>' +
                '</div>' +
                '<div class="rov-cart-font-row">' +
                '<span class="rov-cart-font-label">Font</span>' +
                '<div class="rov-cart-font-opts">' + fontBtns + '</div>' +
                '</div>' +
                '<div class="rov-engrave-actions">' +
                '<button type="button" class="rov-engrave-save">Save</button>' +
                '<button type="button" class="rov-engrave-cancel">Cancel</button>' +
                '</div></div>';
              detailsEl.appendChild(panel);
            }

            // "Add Wooden Box" trigger — 1-to-1: show only when wooden box qty < ring qty so far
            ringRunningQty += item.quantity;
            detailsEl.querySelectorAll('.rov-woodbox-panel').forEach(function (el) { el.remove(); });
            if (woodenBoxVariantId && ringRunningQty > woodenBoxQtyInCart) {
              var wbPanel = document.createElement('div');
              wbPanel.className = 'rov-woodbox-panel';
              wbPanel.innerHTML = '<button type="button" class="rov-woodbox-trigger">+ Add Wooden Box <strong>— $20</strong></button>';
              detailsEl.appendChild(wbPanel);
            }
          });
        });
    }

    // Save engraving: update ring item properties (+ fee product if configured)
    function saveEngraving(itemKey, itemQty, text, font) {
      if (!text) return;

      var engVariantId = getEngravingVariantId();

      showCartLoader();

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var item = cart.items.find(function (i) { return i.key === itemKey; });
          if (!item) { hideCartLoader(); return; }

          var newProps = {};
          Object.keys(item.properties || {}).forEach(function (k) { newProps[k] = item.properties[k]; });
          newProps['Engraving'] = text;
          if (font) newProps['Engraving Font'] = font;

          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: itemKey, properties: newProps })
          })
          .then(function () {
            if (!engVariantId) return;
            var existingEngKey = findPairedEngravingKey(cart, itemKey, engVariantId);
            var chain = Promise.resolve();
            if (existingEngKey) {
              chain = chain.then(function () {
                return fetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: existingEngKey, quantity: 0 })
                });
              });
            }
            return chain.then(function () {
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  id: engVariantId,
                  quantity: itemQty,
                  properties: { 'Ring engraving': text }
                })
              });
            });
          })
          .then(function () { return applyCartUpdates({}); });
        })
        .catch(function () { hideCartLoader(); });
    }

    // Wooden box UI — click handler
    cartDrawer.addEventListener('click', function (e) {
      var wbTrigger = e.target.closest('.rov-woodbox-trigger');
      if (!wbTrigger) return;
      e.stopPropagation();
      e.preventDefault();
      addWoodenBox(wbTrigger);
    }, true);

    // Font selector in cart drawer
    cartDrawer.addEventListener('click', function (e) {
      var fontBtn = e.target.closest('.rov-cart-font-opt');
      if (!fontBtn) return;
      e.stopPropagation();
      e.preventDefault();
      var opts = fontBtn.closest('.rov-cart-font-opts');
      if (opts) opts.querySelectorAll('.rov-cart-font-opt').forEach(function (b) {
        b.classList.remove('rov-cart-font-opt--active');
      });
      fontBtn.classList.add('rov-cart-font-opt--active');
    }, true);

    // Engraving UI — single capture handler for trigger / cancel / save
    cartDrawer.addEventListener('click', function (e) {
      var trigger = e.target.closest('.rov-engrave-trigger');
      var cancel  = e.target.closest('.rov-engrave-cancel');
      var save    = e.target.closest('.rov-engrave-save');
      if (!trigger && !cancel && !save) return;

      e.stopPropagation();
      e.preventDefault();

      if (trigger) {
        var panel = trigger.closest('.rov-engrave-panel');
        var form  = panel.querySelector('.rov-engrave-form');
        trigger.hidden = true;
        form.classList.add('is-open');
        form.querySelector('.rov-engrave-input').focus();
      }

      if (cancel) {
        var panel   = cancel.closest('.rov-engrave-panel');
        var form    = cancel.closest('.rov-engrave-form');
        var trigger = panel ? panel.querySelector('.rov-engrave-trigger') : null;
        form.classList.remove('is-open');
        form.querySelector('.rov-engrave-input').value = '';
        var countEl = form.querySelector('.rov-engrave-count');
        if (countEl) countEl.textContent = '0 / 25';
        if (trigger) trigger.hidden = false;
      }

      if (save) {
        var panel     = save.closest('.rov-engrave-panel');
        var input     = panel.querySelector('.rov-engrave-input');
        var text      = input ? input.value.trim() : '';
        if (!text) { if (input) input.focus(); return; }
        var activeFont = panel.querySelector('.rov-cart-font-opt--active');
        var fontName   = activeFont ? (activeFont.dataset.fontName || activeFont.dataset.fontId || '') : '';
        saveEngraving(panel.dataset.itemKey, parseInt(panel.dataset.itemQty, 10), text, fontName);
      }
    }, true);

    // Engraving char count
    cartDrawer.addEventListener('input', function (e) {
      var input = e.target.closest('.rov-engrave-input');
      if (!input) return;
      var max     = parseInt(input.getAttribute('maxlength'), 10) || 25;
      var used    = input.value.length;
      var countEl = input.closest('.rov-engrave-input-wrap') && input.closest('.rov-engrave-input-wrap').querySelector('.rov-engrave-count');
      if (countEl) {
        countEl.textContent = used + ' / ' + max;
        countEl.classList.toggle('rov-engrave-count--warn', used >= max - 4 && used < max);
        countEl.classList.toggle('rov-engrave-count--full', used >= max);
      }
    });

    // Run patch after every rerender
    if (cartFormWrap) {
      new MutationObserver(function () {
        patchEngravingDisplay();
      }).observe(cartFormWrap, { childList: true, subtree: false });
    }

    // Helper: apply updates map and rerender cart drawer
    function syncCartBadge(count) {
      document.querySelectorAll('.js-cart-count').forEach(function (el) {
        el.textContent = count;
        el.style.display = count > 0 ? '' : 'none';
      });
    }

    async function applyCartUpdates(updates) {
      showCartLoader();
      try {
        var res         = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
        var updatedCart = await res.json();
        var config      = getCartConfig();

        syncCartBadge(updatedCart.item_count);

        if (Shopify.theme && Shopify.theme.ajaxCart) {
          var loaderHidden = false;
          function doHideLoader() {
            if (loaderHidden) return;
            loaderHidden = true;
            hideCartLoader();
          }

          if (cartFormWrap) {
            var obs = new MutationObserver(function () {
              obs.disconnect();
              doHideLoader();
            });
            obs.observe(cartFormWrap, { childList: true, subtree: true });
          }

          Shopify.theme.ajaxCart.updateView(config, updatedCart);
          setTimeout(doHideLoader, 1500);
        } else {
          hideCartLoader();
        }
      } catch (_) {
        hideCartLoader();
      }
    }

    // Helper: find the engraving item paired with a ring item by key
    function findPairedEngravingKey(cart, ringKey, engravingVariantId) {
      var ring = cart.items.find(function (i) { return i.key === ringKey; });
      if (!ring) return null;
      var engText = ring.properties && ring.properties['Engraving'];
      if (!engText) return null;
      var engItem = cart.items.find(function (i) {
        return i.variant_id === engravingVariantId &&
               i.properties && i.properties['Ring engraving'] === engText;
      });
      return engItem ? engItem.key : null;
    }

    // REMOVE — intercept at capture, handle both ring + engraving, rerender once
    cartDrawer.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('.js-cart-remove');
      if (!removeBtn) return;

      e.stopPropagation(); // block theme.js handler
      e.preventDefault();

      var itemKey            = removeBtn.dataset.itemKey;
      var engravingVariantId = getEngravingVariantId();

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var updates = {};
          updates[itemKey] = 0;

          if (engravingVariantId) {
            var engKey = findPairedEngravingKey(cart, itemKey, engravingVariantId);
            if (engKey) updates[engKey] = 0;
          }

          return applyCartUpdates(updates);
        });
    }, true);

    // QTY +/- BUTTONS — intercept at capture before theme.js click handler fires
    cartDrawer.addEventListener('click', function (e) {
      var increaseBtn = e.target.closest('[data-ajax-qty-increase]');
      var decreaseBtn = e.target.closest('[data-ajax-qty-decrease]');
      var btn = increaseBtn || decreaseBtn;
      if (!btn) return;

      e.stopPropagation();
      e.preventDefault();

      var container = btn.closest('.ajax-cart__item-quantity');
      if (!container) return;
      var input = container.querySelector('[data-item-qty]');
      if (!input) return;

      var itemKey            = input.dataset.itemKey;
      var currentQty         = parseInt(input.value, 10);
      var newQty             = increaseBtn ? currentQty + 1 : Math.max(0, currentQty - 1);
      var engravingVariantId = getEngravingVariantId();

      if (!itemKey || isNaN(newQty)) return;

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var updates = {};
          updates[itemKey] = newQty;

          if (engravingVariantId) {
            var engKey = findPairedEngravingKey(cart, itemKey, engravingVariantId);
            if (engKey) updates[engKey] = newQty;
          }

          return applyCartUpdates(updates);
        });
    }, true);

    // QTY INPUT CHANGE — fallback for manual input edits (not +/- buttons)
    cartDrawer.addEventListener('change', function (e) {
      if (!e.target.matches('[data-item-qty]')) return;

      e.stopPropagation();

      var input              = e.target;
      var itemKey            = input.dataset.itemKey;
      var newQty             = parseInt(input.value, 10);
      var engravingVariantId = getEngravingVariantId();

      if (!itemKey || isNaN(newQty) || newQty < 0) return;

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var updates = {};
          updates[itemKey] = newQty;

          if (engravingVariantId) {
            var engKey = findPairedEngravingKey(cart, itemKey, engravingVariantId);
            if (engKey) updates[engKey] = newQty;
          }

          return applyCartUpdates(updates);
        });
    }, true);
  }

  // FAQ scroll button
  document.querySelectorAll('[data-scroll-to-faq]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var faq = document.querySelector('.lfaq__section');
      if (faq) faq.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

});
